import { AdminSidebar } from './AdminSidebar';

interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * AdminLayout component provides the layout structure for all admin pages.
 * Features:
 * - Fixed sidebar navigation on desktop
 * - Responsive behavior for mobile and tablet
 * - Visual distinction from public pages (background color)
 * - Proper spacing and max-width for content
 * 
 * Requirements: 2.1, 2.4, 2.5, 6.1, 6.4
 */
export const AdminLayout = ({ children }: AdminLayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar - Fixed on desktop, responsive on mobile/tablet */}
        <aside className="hidden md:flex md:flex-shrink-0">
          <AdminSidebar />
        </aside>

        {/* Mobile sidebar - Collapsible (future enhancement) */}
        <aside className="md:hidden">
          <AdminSidebar className="h-auto" />
        </aside>

        {/* Main content area */}
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
